// ============================================================
// FAQ ACCORDION
// ============================================================

export function initFaqAccordion() {
    const accordions = document.querySelectorAll('[data-faq-accordion]');
    if (!accordions.length) return;

    accordions.forEach(accordion => {
        const items = accordion.querySelectorAll('.faq-item');
        if (!items.length) return;

        const collapseTimers = new WeakMap();

        const setCollapsed = item => {
            const button = item.querySelector('.faq-item__button');
            const content = item.querySelector('.faq-item__content');
            if (!button || !content) return;

            clearTimeout(collapseTimers.get(content));

            item.classList.remove('is-active');
            button.setAttribute('aria-expanded', 'false');
            content.style.height = '0px';

            const timer = setTimeout(() => {
                if (!item.classList.contains('is-active')) content.hidden = true;
            }, 360);

            collapseTimers.set(content, timer);
        };

        const setExpanded = item => {
            const button = item.querySelector('.faq-item__button');
            const content = item.querySelector('.faq-item__content');
            if (!button || !content) return;

            clearTimeout(collapseTimers.get(content));

            item.classList.add('is-active');
            button.setAttribute('aria-expanded', 'true');
            content.hidden = false;
            content.style.height = content.scrollHeight + 'px';
        };

        items.forEach(item => {
            const button = item.querySelector('.faq-item__button');
            if (!button) return;

            if (item.classList.contains('is-active')) setExpanded(item);
            else setCollapsed(item);

            button.addEventListener('click', () => {
                if (item.classList.contains('is-active')) {
                    setCollapsed(item);
                } else {
                    items.forEach(i => i !== item && setCollapsed(i));
                    setExpanded(item);
                }
            });
        });

        window.addEventListener('resize', () => {
            items.forEach(item => {
                if (!item.classList.contains('is-active')) return;
                const content = item.querySelector('.faq-item__content');
                if (content) content.style.height = content.scrollHeight + 'px';
            });
        });
    });
}